import axios from 'axios'
import {api} from '@/config'

const instance = axios.create({
    baseURL: api.host,
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 60000 // request timeout
})

instance.interceptors.request.use(
    config => {
        if (localStorage.getItem('token')) {
            config.headers['X-Token'] = localStorage.getItem('token')
        }
        return config
    },
    error => Promise.reject(error)
)

instance.interceptors.response.use(
    response => {
        const res = response.data, {responseType = 'json'} = response.config

        //当返回类型非{status,data,msg}的接口请求时，不使用status来判断请求是否成功
        if (!('status' in res) || res.status === 200) {
            //当返回类型为json时，返回response.data
            return responseType === 'json' ? res : response
        }

        //服务器异常
        if (res.status === 500) {
            return responseType === 'json' ? res : response
        }

        //未登录
        if (res.status === 401) {
            console.log('xxxxxxxxx')
            window.location.hash='#/login'
        }

        //没有权限
        if (res.status === 403) {
            // Message.error(res.msg || '没有权限进行该操作')
            return Promise.reject(res.msg)
        }

        //其他错误
        // Message.error(res.msg || '接口有误')
        return Promise.reject(res)
    },
    error => {
        if (axios.isCancel(error)) return
        // error && Notification.error({
        //     title: '错误',
        //     message: '请求错误，请稍后重试'
        // })
        return Promise.reject(error)
    }
)



export default instance
